export const onboardingStatusEnum = Object.freeze({
  COMPLETED: 'completed',
  REQUIRED: 'required',
  NEEDS_STEP_UP: 'needs-step-up',
});
